/**
 * Utilidades V2 para roles y compañías.
 *
 * Solo helpers genéricos y nombres legibles para presentación.
 * NO contiene la matriz de jerarquía (PerfilRol / PerfilCompany) — esa vive
 * exclusivamente en el backend (`functions/utils/userHierarchy.js`) y se
 * consume vía endpoints `/usersV2/role-options/*`.
 *
 * Esto evita exponer la matriz completa en el bundle del cliente.
 */

// Predicados de prefijo de rol (información pública, sin jerarquía)
export const isSA = (rol) => typeof rol === 'string' && rol.startsWith('SA-');
export const isAA = (rol) => typeof rol === 'string' && rol.startsWith('AA-');
export const isUS = (rol) => typeof rol === 'string' && rol.startsWith('US-');

// Catálogo de roles para mostrar nombres legibles en la UI.
// Mantener sincronizado con `functions/controllers/usersAdmin.controller.js` (ROLE_LABELS).
export const rolusers = [
  { id: 'SA-001', name_rol: 'Developer', limit: null },
  { id: 'SA-002', name_rol: 'Comercial', limit: null },
  { id: 'SA-003', name_rol: 'Administrativo', limit: null },
  { id: 'SA-004', name_rol: 'Logistica', limit: null },
  { id: 'SA-005', name_rol: 'Marketing', limit: null },
  { id: 'AA-001', name_rol: 'Admin', limit: 3 },
  { id: 'AA-002', name_rol: 'Provicional', limit: 1 },
  { id: 'AA-003', name_rol: 'Admin Central', limit: 1 },
  { id: 'US-001', name_rol: 'Usuario', limit: null },
  { id: 'US-002', name_rol: 'Usuario Central', limit: null },
  { id: 'US-003', name_rol: 'Usuario Provicional', limit: null },
  { id: 'US-004', name_rol: 'Colaborador', limit: null },
];

export const getRolLabel = (rolId) => {
  if (!rolId) return '—';
  return rolusers.find((r) => r.id === rolId)?.name_rol || rolId;
};

/**
 * Helper de PRESENTACIÓN para gatear UI/router con las capacidades del caller.
 * NO es la matriz: solo consulta el objeto `permissions` que el backend hidrató
 * en `user.permissions` vía `GET /usersV2/my-permissions`.
 *
 * `permissions` tiene forma { moduleKey: [actions...] }.
 * Devuelve true si `moduleKey` incluye `action`.
 */
export const can = (permissions, moduleKey, action) =>
  Array.isArray(permissions?.[moduleKey]) && permissions[moduleKey].includes(action);

// Etiqueta de "categoría" del rol para badges (presentación).
export const getRolCategory = (rolId) => {
  if (isSA(rolId)) return 'Superadmin';
  if (isAA(rolId)) return 'Admin';
  if (rolId === 'US-004') return 'Colaborador';
  if (isUS(rolId)) return 'Usuario';
  return rolId || '—';
};
